import React from "react";
import useAuth from "hooks/useAuth";

const withAuth = (Component) => (props) => {
  const [{ isAuthenticated }] = useAuth();
  return isAuthenticated ? <Component {...props} /> : null;
};

export default withAuth;
